import { Collapse } from "antd";

import { BaseAccordionProps } from "./types";

import "./styles.css";

const BaseAccordion = ({
  className,
  variant = "filled",
  ...props
}: BaseAccordionProps) => {
  return (
    <Collapse
      className={`base-accordion base-accordion-${variant} ${className}`}
      {...props}
    />
  );
};

export default BaseAccordion;
